<template>
  <!-- space-page begin -->
  <div class="space-page">
    <div class="space-page-item space-page-body overflow-hidden">
      <div class="w-75 mb-5 position-relative" style="max-width:640px;">
        <img class="w-100" src="@/assets/images/illustration/undraw_bus-stop.svg" alt="">
        <img src="@/assets/images/illustration/undraw_moto.svg" alt="" class="moto">
      </div>
      <b-progress :value="75" animated height="10px" class="w-50" style="max-width:360px;"></b-progress>
      <span class="font-size-md text-gray600 mt-4 text-center">{{$t('qrcode.loading')}}</span>
    </div>
  </div>
  <!-- space-page end -->
</template>
<script>
export default {
};
</script>

<style>
.moto {
    width: 100%;
    position: absolute;
    left: -40px;
    bottom: -40px;
    -webkit-animation: MotoGoing 5s infinite linear;
    animation: MotoGoing 5s infinite linear;}

@-webkit-keyframes MotoGoing {
    from {left: -200px;}
    to {left: 200%;}
}
@keyframes MotoGoing {
    from {left: -200px;}
    to {left: 200%;}
}
</style>
